import { render } from "./FooterVisulizer.vue?vue&type=template&id=a0354b10&scoped=true"
import script from "./FooterVisulizer.vue?vue&type=script&lang=js"
export * from "./FooterVisulizer.vue?vue&type=script&lang=js"

import "@/assets/css/bootstrap.v4.5.3.basco.min.css?vue&type=style&index=0&id=a0354b10&lang=css&scoped=true&external"
import "@/assets/scss/style.basco.scss?vue&type=style&index=1&id=a0354b10&lang=scss&scoped=true&external"
import "@/assets/scss/responsive.basco.scss?vue&type=style&index=2&id=a0354b10&lang=scss&scoped=true&external"
import "./FooterVisulizer.vue?vue&type=style&index=3&id=a0354b10&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0354b10"]])

export default __exports__